import { IDisposable } from "../IDisposable";
import { CancellationToken } from "../Promises/CancellationTokenSource";
import { IRightsContext } from "./IRightsContext";
import { RightType } from "./RightTypes";
/**
 * Plánovač umožňuje spravovat probíhající vyhodnocení práv a spouštět nová vyhodnocení
 * @includeToDoc
 * @generateInstanceClass
 */
export interface IRightsEvaluationScheduler extends IDisposable {
    /**
     * Naplánuje ke spuštění nové vyhodnocení práv
     * @param rightTypes Typy práv, které se mají znovu vyhodnotit
     * @param context Datový kontext, ke kterému se vztahuje dané vyhodnocení
     * @param evaluator Funkce provádějící vyhodnocení
     * @param priorityRightTypes Typy práv, které se mají prioritně znovu vyhodnotit
     * @param senderUuid Jednoznačný klíč komponenty, která požaduje vyhodnocení práv. Používá se pro optimalizaci.
     * @return Promise umožňující čekat na doběhnutí vyhodnocení, error při chybě nebo CancelError při zrušení celého vyhodnocení
     */
    schedule(rightTypes: RightType[], context: IRightsContext | null, evaluator: IRightsEvaluationFunction, priorityRightTypes?: RightType[], senderUuid?: string): Promise<void>;
}

export class IRightsEvaluationScheduler {
    private static _properties: string[] = [];
    private static _methods = ["schedule"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function") &&
            instance instanceof IDisposable;
    }
}

/**
 * Funkce provádějící vyhodnocení práv
 * @includeToDoc
 */
export interface IRightsEvaluationFunction {
    /**
     * Funkce provádějící vyhodnocení práv
     * @param rightDefinitions Kolekce práv k vyhodnocení spolu s jejich cancellation tokeny, které umožňují zrušení toho konkrétního práva
     * @param context Datový kontext, ke kterému se vztahuje dané vyhodnocení
     * @param ct Cancellation token umožňující zrušení celého vyhodnocení
     * @param priorityRightDefinitions Kolekce prioritních práv k vyhodnocení spolu s jejich cancellation tokeny, které umožňují zrušení toho konkrétního práva
     * @returns Promise umožňující čekat na doběhnutí vyhodnocení, error při chybě nebo CancelError při zrušení celého vyhodnocení
     */
    (rightDefinitions: { type: RightType; ct: CancellationToken }[], context: IRightsContext | null, ct: CancellationToken, priorityRightDefinitions?: { type: RightType; ct: CancellationToken }[]): Promise<void>;
}
